<template>
    <zen-one
        :showuserinfo="false"
        :crumbs="crumbs"
        title="Sistem Hasil Bersepadu Kedah (iHasil)"
    >
        <z-page title="Kaunter : Tutup Akhir">
            <div class="message-box">
                <w-transition-fade>
                    <w-alert
                        class="my0 text-light"
                        v-if="form.submitted"
                        success
                        no-border
                    >
                        The form is valid, ready to send it!
                    </w-alert>

                    <w-alert
                        class="my0 text-light"
                        v-else-if="form.valid === false"
                        error
                        no-border
                    >
                        Terdapat {{ form.errorsCount }} ralat di dalam borang
                        ini.
                    </w-alert>
                </w-transition-fade>
            </div>

            <w-form
                class=""
                v-model="form.valid"
                v-model:errors-count="form.errorsCount"
                @validate="onValidate"
                @success="onSuccess"
            >
                <w-flex justify-center align-center>
                    <div class="xs3">
                        <h5 class="fw-semibold m0">Tarikh :</h5>
                        <div class="fw-normal my1 fs-1">
                            {{ currentDate() }}
                        </div>
                    </div>
                    <div class="xs3">
                        <h5 class="fw-semibold m0">Kaunter :</h5>
                        <div class="fw-normal my1 fs-1">
                            <template v-if="form.kaunter">{{
                                form.kaunter.kod
                            }}</template>
                        </div>
                    </div>
                    <div class="xs3">
                        <h5 class="fw-semibold m0">Cara Bayaran :</h5>
                        <div class="fw-normal my1 fs-1">
                            <template v-if="form.cara_bayar">{{
                                form.cara_bayar.keterangan
                            }}</template>
                        </div>
                    </div>
                    <div class="xs3">
                        <h5 class="fw-semibold m0">Status :</h5>
                        <div class="fw-normal my1 fs-1">
                            <template v-if="form.status">{{
                                form.status.keterangan
                            }}</template>
                        </div>
                    </div>
                </w-flex>
                <w-flex justify-center align-center class="mt5">
                    <div class="w-card__content content-hardcode">
                        <table class="w-table" width="100%">
                            <thead>
                                <tr>
                                    <th class="w-table__header"><b>No. </b></th>
                                    <th class="w-table__header">
                                        <b>No. Resit </b>
                                    </th>
                                    <th class="w-table__header">
                                        <b>Cara Bayaran (RM)</b>
                                    </th>
                                    <th class="w-table__header">
                                        <b>No Dokumen </b>
                                    </th>
                                    <th class="w-table__header">
                                        <b>Amaun (RM)</b>
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(dt, index) in form.resit">
                                    <td class="table__cell" align="center">
                                        {{ index + 1 }}
                                    </td>
                                    <td class="table__cell">
                                        {{ dt.no_resit }}
                                    </td>
                                    <td class="table__cell">
                                        <template
                                            v-if="
                                                dt.cara_bayaran
                                                    .is_update_cara_bayaran == 1
                                            "
                                        >
                                            <z-lookup
                                                name="kaedah_bayaran"
                                                :url="
                                                    service_utiliti +
                                                    'lookup/cara_bayar'
                                                "
                                                :sort="false"
                                                :cache="false"
                                                v-model="dt.lkp_cara_bayaran_id"
                                                required
                                                :validators="[
                                                    validators.required,
                                                ]"
                                            />
                                        </template>
                                        <template v-else>
                                            {{ dt.cara_bayaran_keterangan }}
                                        </template>
                                    </td>
                                    <td class="table__cell">
                                        <template
                                            v-if="
                                                dt.cara_bayaran
                                                    .is_update_rujukan == 1
                                            "
                                        >
                                            <w-input
                                                v-model="dt.no_dokumen"
                                                :validators="[
                                                    validators.required,
                                                ]"
                                            />
                                        </template>
                                        <template v-else>
                                            {{ dt.no_dokumen }}
                                        </template>
                                    </td>
                                    <td class="table__cell" align="right">
                                        {{ $zutil.currency(dt.amaun) }}
                                    </td>
                                </tr>
                                <tr><td></td><td colspan="3"><b>Jumlah</b></td><td align="right"><b>{{ $zutil.currency(form.resit_amaun) }}</b></td></tr>
                            </tbody>
                        </table>
                    </div>
                </w-flex>

                <w-flex class="mt4" wrap align-center justify-end>
                    <div class="spacer" />
                    <template v-if="$zutil.can('Kaunter Tutup Akhir')">
                        <w-button
                            class="my1"
                            type="submit"
                            :disabled="form.valid === false"
                            :loading="form.submitted && !form.sent"
                        >
                            <w-icon dark tile>fal fa-save</w-icon>
                        </w-button>
                    </template>
                </w-flex>
            </w-form>
        </z-page>
    </zen-one>
</template>

<script>
import Vue3ChartJs from "@j-t-mcc/vue3-chartjs";
import ZResource from "@/Modules/z-resource-service";

export default {
    extends: ZResource,
    components: {
        Vue3ChartJs,
    },
    props: {
        id: [Array, Object, String],
        status: [Array, Object, String],
    },
    setup() {
        const doughnutChart = {
            id: "doughnut",
            type: "doughnut",
            data: {
                labels: ["VueJs", "EmberJs", "ReactJs", "AngularJs"],
                datasets: [
                    {
                        backgroundColor: [
                            "#37479e",
                            "#2f3d88",
                            "#273371",
                            "#1f285a",
                        ],
                        data: [40, 20, 80, 10],
                    },
                ],
            },
            options: { plugins: { legend: { display: false } } },
        };

        const beforeRenderLogic = (event) => {
            //...
            //if(a === b) {
            //  event.preventDefault()
            //}
        };

        return {
            doughnutChart,
            beforeRenderLogic,
        };
    },
    data() {
        return {
            resourceurl: this.service_kutipan + "kaunter/resit",
            dialog: {
                show: false,
                show2: false,
                fullscreen: false,
                persistent: false,
                persistentNoAnimation: false,
                width: 500,
            },
            form: {
                valid: null,
                submitted: false,
                sent: false,
                errorsCount: 0,
            },
            validators: {
                required: (value) => !!value || "This field is required",
                consent: (value) => !!value || "You must agree",
            },
            crumbs: [
                { label: "iHasil", route: "/" },
                { label: "Kutipan", route: "kutipan" },
                { label: "Kaunter", route: "kutipan/kaunter" },
                { label: "Tutup Akhir", route: "kutipan/kaunter/akhir" },
                { label: "Resit", route: "/Kaunter/resit" },
            ],
            showCard: false,
        };
    },
    methods: {
        onSuccess() {
            this.$zcomm
                .post(this.resourceurl + "/update", this.form)
                .then((res) => {
                    this.$inertia.visit(window.route("kutipan.kaunter.akhir"));
                });
        },
        onValidate() {
            this.form.sent = false;
            this.form.submitted = this.form.errorsCount === 0;
        },

        currentDate() {
            const current = new Date();
            const date = `${current.getDate()}/${
                current.getMonth() + 1
            }/${current.getFullYear()}`;
            return date;
        },
        getData() {
            this.$zcomm
                .get(this.resourceurl + "/" + this.id + "/" + this.status)
                .then((res) => {
                    this.form = res;
                });
        },
    },

    mounted() {
        // this.getData();
    },
};
</script>

<style></style>
